import React, { useContext, useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive'

import * as ImageFile from '../../../Global/ImageFile';
import BuilderContext from "../../../../builder/hooks/context";
import {device} from "../../../../const/device";
import {sides} from "../../../../const/sides";

function AdditionalImage() {
    const { builder } = useContext(BuilderContext);
    const isMobile = useMediaQuery({ query: `(${device.mobileL})` })
    const isTablet = useMediaQuery({ query: `(${device.tablet})` });
    const [side, setSide] = useState(isMobile ? 'front' : 'front');

    const getSleeveSide = (side) => {
        if([sides.LEFT, sides.RIGHT].includes(side) && !builder?.options?.sleeve) return `${side}_long`;
        return side;
    }

    return(
        <>
            <ImageFile.BaseContainer
                minimal={1}
                hasPreview={true}
                side={side}
                setImage={(image, index, public_url) =>
                    builder.imagesData.updateSponsorImage(side, index, image, public_url)
                }
                images={builder.imagesData.sponsorImages[getSleeveSide(side)]}
            />
        </>
    );
}

export default React.memo(AdditionalImage);